<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faWhatsapp,faFacebookF,faYoutube,faMeta,faSnapchat,faTiktok} from "@fortawesome/free-brands-svg-icons";
//import { faMeta } from "@fortawesome/pro-brands-svg-icons";

import { faMobileNotch,faBrowser,faCommentLines,faAngleRight } from '@fortawesome/pro-light-svg-icons'

import {
  REGAL_EYES_ADVERTISER_ID,
  REGAL_EYES_CAMPAIGN_ID,
  REGAL_EYES_CAMPAIGN_NAME,
  REGAL_EYES_TOTALS,
  REGAL_EYES_BUDGET,
} from '@utils/regal-eyes'

library.add(faWhatsapp,faMobileNotch,faBrowser,faFacebookF,faCommentLines,faAngleRight,faYoutube,faMeta,faSnapchat,faTiktok);



export default {
  page: {
    title: 'Campaigns List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader,FontAwesomeIcon },
  methods:
  {
    comingSoon: function(){
      this.$bvModal.msgBoxOk("This feature is comming soon we will email you once we lunch it.", {titleHtml: "<b>Alert<b>"});
    },
    campaign_details: function(id){
      this.$router.push('/campaigns/overview/'+id);
    },
    add_campaign: function(type)
    { 
        //alert(this.PageComponents.selected_advertiser);

        if(typeof this.PageComponents.selected_advertiser.id !== 'number' || parseInt(this.PageComponents.selected_advertiser.id) == 0){
           this.$bvModal.msgBoxOk("Please select your advertiser first" , {titleHtml: "<b>Error<b>"});
        }
        else
        {
          this.PageComponents.campaigns_loading = true;
          
          axios.post(appConfig.api+'campaigns/draft/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser")),advertiser:this.PageComponents.selected_advertiser.id,type:type})
          .then((response) =>
          { 
            if(response.data)
            {
              if(response.data.status == false)
              {
                if(response.data.code == 401)
                {
                  //invalud session
                  this.$router.push('/logout');
                }
                else
                {
                  this.PageComponents.campaigns_loading = false;
                  this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
                }
              }
              else
              {

                  if(response.data.id !== undefined){
                    this.$router.push('/campaigns/edit/'+response.data.id);
                    this.PageComponents.campaigns_loading = false;
                  }
                  else
                  {
                     this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
                  }
              }
            }
            else
            {
              this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
            }

          })
          .catch((error) =>
          {
              //other error
              this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
          });
        }
    },
    GetCampaignsList: function()
    {

        //set advertiser id
        var uinfo = JSON.parse(localStorage['auth.currentUser']);
        if(uinfo.advertiser !== undefined){
			    this.PageComponents.selected_advertiser = {name:uinfo.advertiser.name,id:uinfo.advertiser.id};
        }
        else
        {
          this.PageComponents.selected_advertiser = {name:'',id:0};
        }

        this.PageComponents.ajax_loading = true;

        axios.post(appConfig.api+'campaigns/list/', {uinfo:JSON.parse(localStorage.getItem("auth.currentUser"))})
				.then((response) =>
				{ 
            this.PageComponents.ajax_loading = false;

            if(response.data)
						{
							if(response.data.status == false)
							{
									if(response.data.code == 401)
									{
											//invalud session
											this.$router.push('/logout');
									}
									else
									{
										this.PageComponents.hasError = true;
										this.PageComponents.errorMsgs = response.data.error_message;
									}
							}
							else
							{
                //success Status
                this.List = this.injectRegalEyesRow(response.data.list || []);
							}
						}
						else
						{
							this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
						}


        })
				.catch((error) =>
				{
						//other error
						this.$bvModal.msgBoxOk("Sorry we are facing a problem in our servers. Please try again later", {titleHtml: "<b>Network Error<b>"});
				})
    },
    /**
     * If the current advertiser is Regal Eyes, surface the synthetic
     * "Regal Eyes - Social 2026" campaign at the top of the list. The
     * row's action_id points at the special detail route handled in
     * campaigns/details/index.vue.
     */
    injectRegalEyesRow: function(list)
    {
      var advertiserId = Number(this.PageComponents.selected_advertiser.id) || 0;
      if(advertiserId !== REGAL_EYES_ADVERTISER_ID){
        return list;
      }

      var alreadyPresent = list.some(function(row){
        return row && row.action_id === REGAL_EYES_CAMPAIGN_ID;
      });
      if(alreadyPresent){
        return list;
      }

      var formatNumber = function(n){
        return n.toLocaleString();
      };
      var formatMoney = function(n){
        return n.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2});
      };

      var ctrPct = REGAL_EYES_TOTALS.impressions > 0
        ? ((REGAL_EYES_TOTALS.clicks / REGAL_EYES_TOTALS.impressions) * 100).toFixed(3)
        : '0.000';

      var syntheticRow = {
        id: 'RE-2026',
        action_id: REGAL_EYES_CAMPAIGN_ID,
        name: REGAL_EYES_CAMPAIGN_NAME,
        start_time: 'Feb 1 2026',
        end_time: 'Apr 30 2026',
        remaining_days: 'Completed',
        budget_amount: formatMoney(REGAL_EYES_BUDGET),
        total_spent: formatMoney(REGAL_EYES_TOTALS.spend),
        lifetime_impressions: formatNumber(REGAL_EYES_TOTALS.impressions),
        lifetime_clicks: formatNumber(REGAL_EYES_TOTALS.clicks),
        lifetime_CPM: 'CTR ' + ctrPct + '%',
      };

      return [syntheticRow].concat(list);
    }
  },
  created: function() {
     this.GetCampaignsList();
  },
  data() 
  {
    
    return {
      title: 'Campaigns',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Campaigns',
          href: '/campaigns',
        },
        {
          text: 'List',
          active: true,
        }
      ],
      PageComponents:{
        ajax_loading:true,
        campaigns_loading:false,
        selected_advertiser:{id:0}
      },
      List: [],
      listFields:[
        { key: 'id', label: 'ID', sortable: false},
        { key: 'name', label: 'Campaign Name', sortable: true, sortDirection: 'desc' },
        { key: 'start_time', label: 'Start Date', sortable: true },
        { key: 'end_time', label: 'End Date', sortable: true },
        { key:'budget_amount',label:'Budget',sortable:true},
        { key:'total_spent',label:'Spent',sortable:true},
        { key: 'lifetime_impressions', label: 'Impressions', sortable: true },
        { key: 'lifetime_clicks', label: 'Clicks', sortable: true },
        { key: 'action_id', label: 'Overview',sortable: false },
        
      ]
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
   <b-alert variant="danger" show dismissible v-show="PageComponents.hasError">
			<ul>
				<li v-for="error in PageComponents.errorMsgs">{{ error }}</li>
			</ul>
		</b-alert>

 <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            
            

          <div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col">
								<h4 class="header-title mt-0 mb-1">Campaigns List</h4>
							
							</div>
							<div class="col text-right">
							

               <b-button variant="outline-primary" class="float-right"   v-b-modal.campaignModal  :disabled="PageComponents.campaigns_loading"> Add New</b-button>


              <b-modal id="campaignModal" title="Select your campaign type" ok-only ok-variant="light" ok-title="Cancel">
                <div>
                  <b-overlay :show="PageComponents.campaigns_loading" rounded="sm">
                    <ul class="list-unstyled">
                      
                      <b-media tag="li">
                        <template #aside>
                            <b-img src="https://www.foxpush.com/images/foxpush_logo.png" blank-color="#abc" width="64" alt="placeholder"></b-img>
                        </template>
                        <h5 class="mt-0 mb-1">
                          <b-link @click="add_campaign('direct');">FoxPush Premium</b-link></h5>
                        <p class="mb-0">
                          Maximize reach with targeted ads across premium websites and apps.
                        </p>
                      </b-media>

                      <br />


                      <b-media tag="li">
                        <template #aside>
                            <font-awesome-icon icon="fa-light fa-browser" style="width: 64px;height: 64px;" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('web');">Web Environment</b-link></h5>
                        <p class="mb-0">
                          Display or video ads that serve on web inventory.
                        </p>
                      </b-media>

                      <br />


                      <b-media tag="li">
                        <template #aside>
                            <font-awesome-icon style="width: 64px;height: 64px;" icon="fa-light fa-mobile-notch" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('apps');">Apps Environment</b-link></h5>
                        <p class="mb-0">
                          Display or video ads that serve on mobile apps inventory.
                        </p>
                      </b-media>

                      <br />

                      <b-media tag="li">
                        <template #aside>
                            <font-awesome-icon style="width: 64px;height: 64px;" icon="fa-brands fa-youtube" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('youtube');">YouTube </b-link>  </h5> 
                        <p class="mb-0">
                          Reach engaged viewers and drive conversions with video ads.
                        </p>
                      </b-media>

              

                      <br />

                      

                      <b-media tag="li">
                        
                        <template #aside>
                            <font-awesome-icon style="width: 64px;height: 64px;" icon="fa-brands fa-meta" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('meta');">Meta </b-link></h5> 
                        <p class="mb-0" style="height: 64px;display: block;">
                          Reach and engage audiences on Facebook and Instagram to drive results.
                        </p>
                        
                      </b-media>

                      <b-media tag="li">
                        <template #aside>
                            <font-awesome-icon style="width: 64px;height: 64px;" icon="fa-brands fa-snapchat" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('snapchat');">Snapchat Ads </b-link></h5> 
                        <p class="mb-0" style="height: 64px;display: block;">
                          Connect with a younger audience through interactive ads.
                        </p>
                      </b-media>


                      <b-media tag="li">
                       
                        <template #aside>
                            <font-awesome-icon style="width: 64px;height: 64px;" icon="fa-brands fa-tiktok" />
                        </template>
                        <h5 class="mt-0 mb-1"><b-link @click="add_campaign('tiktok');">TikTok Ads </b-link></h5> 
                        <p class="mb-0">
                          Drive impact with creative short videos.
                        </p>
                      
                      </b-media>

                    
                    </ul>
                  </b-overlay>
                </div>
              </b-modal>

							</div>
						</div>
					</div>
					<!-- end card body-->
				</div>
				<!-- end card -->
			</div>
			<!-- end col-12 -->
		      </div>

            <div>
              <div>
               
                <b-table :items="List" :fields="listFields" hover :busy="PageComponents.ajax_loading" show-empty>
                  <template #cell(id)="row">
                    {{row.item.id}}
                  </template> 
                  <template #cell(name)="row">
                    <b-link v-on:click="campaign_details(row.item.action_id);">{{ row.item.name }}</b-link>
                  
                  </template>
                  
     

                  <template #cell(budget_amount)="row">
                    ${{row.item.budget_amount}}
                  </template>  
                  <template #cell(total_spent)="row">
                    <span v-b-tooltip.hover :title="row.item.lifetime_CPM"> ${{row.item.total_spent}}</span>
                  </template>  
         

                  <template #cell(end_time)="row">
                    <span v-b-tooltip.hover :title="row.item.remaining_days">{{row.item.end_time}}</span>
                  </template>  


                  <template #cell(lifetime_impressions)="row">
                    <span v-b-tooltip.hover :title="row.item.lifetime_CPM"> {{row.item.lifetime_impressions}}</span>
                  </template>

                  

                  <template #cell(action_id)="row">
                    <b-link v-on:click="campaign_details(row.item.action_id);">
                      <font-awesome-icon style="width: 20px; height: 20px;" icon="fa-light fa-angle-right" />  
                    </b-link>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle" variant="primary"></b-spinner>
                      <div class="text-muted font-size-13">Please wait ...</div>
                    </div>
                  </template>  

                  <template #empty="scope">
                       <p class="text-center">You don't have any campaigns yet for this advertiser</p>
                  </template>

          
                  
                </b-table>
              </div>

            </div>


          </div>
        </div>
      </div>

     
    </div>

    <!-- end row -->
  </Layout>
</template>
